// 🔧 index.js
// ✅ Purpose: Entry point for the Vendor Engine
// ✅ Features:
// - Exposes runVendorEngine()
// - Keeps Vendor Engine imports clean for pipeline steps
// - Runs Vendor Builder when the Vendors add-on is selected
// - Returns standardized Demo Report v2-compatible results
// - Fully block-commented for clarity and future devs

import { buildVendors } from "./vendor_builder";

export const runVendorEngine = async ({
  demoContext,
} = {}) => {
  console.log("🏪 Vendor Engine started.");

  const result = await buildVendors({
    demoContext,
  });

  console.log("✅ Vendor Engine completed.", {
    result,
  });

  return result;
};